// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".adm-doctor-head[data-v-8d22dc16]{display:flex;align-items:center;gap:16px;margin-bottom:20px}.adm-doctor-head__id[data-v-8d22dc16]{font-size:13px;margin-top:6px}.adm-confirm-text[data-v-8d22dc16]{margin:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
